import { Dialog, Grid } from '@material-ui/core';
import React, { useState } from 'react';
import Header from '../../lib/AppBar';
import Footer from '../../lib/Footer';

import en from '../../lang/en-us';
import ResetDevices from './ResetDevices';

const {
    login: { quickLinks, applyPan, form: LoginForm },
    signUp: { form: SignupForm },
} = en;

function QuickLinksCard({
    imgSrc,
    title,
    url = '#',
}: {
    imgSrc: string;
    title: string;
    url: string;
}) {
    return (
        <div className="quick-links-info">
            <a href={url}>
                <img src={imgSrc} alt="icon" />
                <p>{title}</p>
            </a>
        </div>
    );
}

const links = [
    { imgSrc: '/images/update-pan.svg', url: '#', title: quickLinks.pan.title },
    { imgSrc: '/images/transmission-login.svg', url: '#', title: quickLinks.transmission.title },
];
export default function Wrapper({ children, ...props }: any) {
    const [show, setShow] = useState<boolean>(false);
    const setDataByPath = (): any => {
        const { pathname = '' } = props.location;
        const { path: BASE_PATH = '' } = props.match;
        switch (pathname) {
            case `${BASE_PATH}/signin`:
                return { img: 'signin-img.png', extraClass: 'signin-left', ...LoginForm };
            case `${BASE_PATH}/forgot-password`:
                return { img: 'signin-img.png', extraClass: 'signin-left', ...LoginForm };
            case `${BASE_PATH}/forgot-password-otp`:
                return { img: 'signin-img.png', extraClass: 'signin-left', ...LoginForm };
            case `${BASE_PATH}/forgot-password-questionnaire`:
                return { img: 'signin-img.png', extraClass: 'signin-left', ...LoginForm };
            case `${BASE_PATH}/reset-password`:
                return { img: 'signin-img.png', extraClass: 'signin-left', ...LoginForm };
            case `${BASE_PATH}/signup`:
                return { img: 'signup-img.png', extraClass: 'signup-left', ...SignupForm };
            case `${BASE_PATH}/signup-otp`:
                return { img: 'signup-img.png', extraClass: 'signup-left', ...SignupForm };
            case `${BASE_PATH}/set-password`:
                return { img: 'signup-img.png', extraClass: 'signup-left', ...SignupForm };
            case `${BASE_PATH}/signin-questionnaire`:
                return { img: 'signin-img.png', extraClass: 'signin-left', ...LoginForm };
            case `${BASE_PATH}/reset-question-otp`:
                return { img: 'signin-img.png', extraClass: 'signin-left', ...LoginForm };
            default:
                return { img: 'signin-img.png', extraClass: 'signin-left' };
        }
    };

    const {
        img,
        title1 = '',
        secondaryTitle = '',
        titleCaption = '',
        extraClass,
    } = setDataByPath();

    return (
        <>
            <Header {...props} />
            <div className="container-fluid">
                <div className="login-content-outer">
                    <div className="maxWidth login-container">
                        <div className="login-content">
                            <div className="login-content-inner">
                                <div className={`login-content-left ${extraClass}`}>
                                    <h3>
                                        {title1} <span>{secondaryTitle}</span>
                                    </h3>
                                    <h5>{titleCaption}</h5>
                                    <img src={`/images/${img}`} alt="icon" />
                                </div>

                                <div className="login-content-right">{children}</div>
                            </div>
                        </div>
                        <div className="quick-links">
                            <div className="quick-links-text">
                                <h3>
                                    {quickLinks.title} <span>{quickLinks.secondaryTitle}</span>
                                </h3>
                                <p>{quickLinks.easyAccess}</p>
                            </div>
                            <div className="quick-links-cards">
                                <div className="quick-links-info">
                                    <a onClick={() => props.history.push('/links/purchase')}>
                                        <img src="/images/explore-mf.svg" alt="icon" />
                                        <p>{quickLinks.explore.title}</p>
                                    </a>
                                </div>

                                <div className="quick-links-info">
                                    <a onClick={() => props.history.push('/links')}>
                                        <img src="/images/update-pan.svg" alt="icon" />
                                        <p>{quickLinks.pan.title}</p>
                                    </a>
                                </div>
                                <div className="quick-links-info">
                                    <a onClick={() => setShow(!show)}>
                                        <img src="/images/apply-pan.svg" alt="icon" />
                                        <p>{quickLinks.applyPan.title}</p>
                                    </a>
                                </div>
                                <div className="quick-links-info">
                                    <a
                                        onClick={() =>
                                            props.history.push('/links/transmission-request')
                                        }
                                    >
                                        <img
                                            src="/images/transmission-login.svg"
                                            // src="/images/transmission-login-comingsoon.svg"
                                            alt="icon"
                                        />
                                        <p>{quickLinks.transmission.title}</p>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
            <Dialog fullWidth maxWidth={'md'} open={show} aria-labelledby="applyPanModal">
                <div className="applyPanModal">
                    <div className="modal-dialog modal-dialog-centered">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h4 className="modal-title">{applyPan.heading}</h4>
                                <a onClick={() => setShow(!show)}>
                                    <img src="/images/close-black.svg" alt="icon" />
                                </a>
                            </div>
                            <div className="modal-body">
                                <h6>{applyPan.info}</h6>
                                <h6>{applyPan.infoBottom}</h6>
                                <div className="pan-links">
                                    <img
                                        src="/images/attachment.svg"
                                        alt="icon"
                                        className="pan-attachment-img"
                                    />
                                    <div className="pan-website-img">
                                        <img src="/images/nsdl.png" alt="icon" />
                                    </div>
                                    <p>NSDL</p>
                                    <a
                                        href="https://www.onlineservices.nsdl.com/paam/endUserRegisterContact.html"
                                        target="_blank"
                                    >
                                        {applyPan.clickHere}
                                    </a>
                                </div>
                                <div className="pan-links">
                                    <img
                                        src="/images/attachment2.svg"
                                        alt="icon"
                                        className="pan-attachment-img"
                                    />
                                    <div className="pan-website-img">
                                        <img src="/images/utiitsl.png" alt="icon" />
                                    </div>
                                    <p>UTIITSL</p>
                                    <a
                                        href="https://www.pan.utiitsl.com/PAN/mainform.html"
                                        target="_blank"
                                    >
                                        {applyPan.clickHere}
                                    </a>
                                </div>
                                <div className="pan-info">
                                    <p>
                                        {applyPan.websiteInfo}{' '}
                                        <a
                                            href="https://www.incometaxindia.gov.in/Pages/tax-services/apply-for-pan.aspx"
                                            target="_blank"
                                        >
                                            https://www.incometaxindia.gov.in/Pages/tax-services/apply-for-pan.aspx
                                        </a>{' '}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Dialog>
        </>
    );
}
